import script from "./KTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./KTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./KTooltip.vue?vue&type=style&index=0&id=54512056&lang=sass"

const __exports__ = script;

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
